const landingConfig = ($stateProvider) => {

  'ngInject';

  $stateProvider
    .state('landing', {
      url: '/',
      template: '<app-landing></app-landing>',
      access: {
        loginRequired: false,
      },
    })
    .state('meredicte', {
      url: '/meredicte',
      template: '<app-meredicte></app-meredicte>',
      access: {
        loginRequired: false,
      },
    })
    .state('thesafezone', {
      url: '/thesafezone',
      template: '<app-thesafezone></app-thesafezone>',
      access: {
        loginRequired: false,
      },
    });
};

export default landingConfig;



// WEBPACK FOOTER //
// ./src/modules/landing/landing.config.js